var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F66957"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.25L18.25 16M18.25 16L16 13.75M18.25 16L10 16M10 19.75C10 20.4489 10 20.7984 10.1142 21.074C10.2664 21.4416 10.5586 21.7336 10.9261 21.8858C11.2018 22 11.5511 22 12.25 22H19.6C20.4401 22 20.86 22 21.1808 21.8365C21.4631 21.6927 21.6929 21.4633 21.8367 21.181C22.0002 20.8602 22 20.44 22 19.6V12.4C22 11.5599 22.0002 11.1399 21.8367 10.819C21.6929 10.5368 21.4631 10.3073 21.1808 10.1635C20.86 10 20.4401 10 19.6 10H12.25C11.5511 10 11.2018 10 10.9261 10.1142C10.5586 10.2664 10.2664 10.5584 10.1142 10.926C10 11.2016 10 11.5511 10 12.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.98c97d07a27689956eca30e190e49773.svg";
export { ForwardRef as ReactComponent };